import { useState } from "react";
import CraftBlockPredictionCombineWindow from "./CraftBlockPredictionCombineWindow";

const CraftBlockPredictionCombine = () => {

  const [isCombine, setIsCombine] = useState();

  const clickHandler = (e) => {
    e.stopPropagation();
    setIsCombine(!isCombine)
  }

  return (
    <>
      <button className="craft-block__step-combine" onClick={clickHandler}>Combine Cards</button>

      {
        isCombine && <CraftBlockPredictionCombineWindow close={clickHandler} />
      }
    </>
  )
}

export default CraftBlockPredictionCombine
